function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("defs", null);
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Notification-off"
}, React.createElement("path", {
  className: "cls-1",
  d: "M7,13.764a2.455,2.455,0,0,0,2.552-1.983h-5.1A2.454,2.454,0,0,0,7,13.764Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M9.414.934a4.735,4.735,0,0,0-2.272-.7A4.872,4.872,0,0,0,2.094,4.864V6.582a1.323,1.323,0,0,1-.387.935L.194,9.306a.659.659,0,0,0-.04.89Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M12.263,7.517a1.323,1.323,0,0,1-.387-.935V5.058a4.351,4.351,0,0,0-.265-1.451l2.138-2.138A.861.861,0,0,0,12.532.251l-1.8,1.8h0L6.707,6.077.255,12.531a.861.861,0,0,0,1.217,1.218l3.313-3.314h8.552a.662.662,0,0,0,.468-1.129Z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
};
export default __webpack_public_path__ + "static/media/notification-off.ae673d2e.svg";
export { SvgComponent as ReactComponent };